import {
  INCLUSION_PREVIEW,
  INCLUSION_NEW,
  INCLUSION_UPDATE,
  INCLUSION_REMOVE,
  INCLUSION_PROCESS_SUCCESS,
  INCLUSION_DATASOURCE_SUCCESS,
  INCLUSION_SEARCH,
  INCLUSION_PROCESS_RESET
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize:{},
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case INCLUSION_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case INCLUSION_NEW: {
      return {
          ...state,
          loader: true,
          process:{status:false,action:"",message:""}
      }
    }
    case INCLUSION_UPDATE:{
        return{
          ...state,
          loader:true,
          process:{status:false,action:"",message:""},
          dataSerialize:action.payload
        }
    }
    case INCLUSION_REMOVE: {
      return {
          ...state,
          loader: false,
          process:{status:false,action:"",message:""}
      }
    }
    case INCLUSION_SEARCH:{
        return {
            ...state,
            loader:false,
            keyword:action.payload
        }
    }
    case INCLUSION_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process:action.payload
      }
    }
    case INCLUSION_DATASOURCE_SUCCESS:{
        return {
            ...state,
            loader: false,
            dataSource: action.payload
        }
    }
    case INCLUSION_PROCESS_RESET:{
      return{
        ...state,
        process:{}
      }
    }
    default:
      return state
  }
}